import React, { useMemo } from 'react';
import './App.css';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink
} from "@apollo/client";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GameOfTheDay from './GameOfTheDay';
import SpecialPuzzle from './SpecialPuzzle';
import AdminPage from './components/AdminPage';
import { useLocalStorage } from './utils/useLocalStorage';
import { getTodaysDate } from './utils/gameUtils';

const API_URL = process.env.REACT_APP_PUZZLI_API_URL;

const httpLink = new HttpLink({
  uri: API_URL,
  fetch,
  headers: {
    'Content-Type': 'application/json',
  },
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

export default function App() {
  const { getItem: getStoredUserId } = useLocalStorage('userId');
  const userId = getStoredUserId();
  
  const showSpecialPuzzle = useMemo(() => {
    const specialId = process.env.REACT_APP_PUZZLI_SPECIAL_ID;
    const specialDate = process.env.REACT_APP_PUZZLI_SPECIAL_DATE;
    const today = getTodaysDate();
    const result = userId && specialId && userId.endsWith(specialId) && specialDate && today === specialDate;
    return result;
  }, [userId]);

  return (
    <div className="App">
      <ApolloProvider client={client}>
        <Router>
          <Routes>
            <Route path="/" element={showSpecialPuzzle ? <SpecialPuzzle /> : <GameOfTheDay />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </Router>
      </ApolloProvider>
    </div>
  );
}
